<script setup lang="ts">
import { computed, type Component } from 'vue'
import { cx } from './cx'

const props = defineProps<{
  label: string
  value: number | string
  unit?: string
  hint?: string
  tone?: 'accent' | 'ok' | 'default'
  icon?: Component
}>()

const color = computed(() =>
  props.tone === 'accent' ? 'text-accent-dim' : props.tone === 'ok' ? 'text-ok' : 'text-text',
)

const bar = computed(() =>
  props.tone === 'accent'
    ? 'bg-accent'
    : props.tone === 'ok'
      ? 'bg-ok'
      : 'bg-line-strong',
)

const iconWrap = computed(() =>
  props.tone === 'accent'
    ? 'bg-accent/12 text-accent-dim'
    : props.tone === 'ok'
      ? 'bg-ok/10 text-ok'
      : 'bg-raised text-muted',
)
</script>

<template>
  <div class="panel relative overflow-hidden px-5 py-4">
    <span :class="cx('absolute top-0 bottom-0 left-0 w-[3px]', bar)" />
    <div class="flex items-start justify-between gap-3 pl-1">
      <div class="min-w-0">
        <p class="text-[12px] font-semibold tracking-[0.04em] text-dim uppercase">{{ label }}</p>
        <p :class="cx('mt-2 flex items-baseline gap-1.5', color)">
          <span class="font-mono tabular-nums text-[30px] font-semibold tracking-tight">{{ value }}</span>
          <span v-if="unit" class="text-[13px] font-medium text-dim">{{ unit }}</span>
        </p>
        <p v-if="hint" class="mt-1.5 text-[12px] text-dim">{{ hint }}</p>
      </div>
      <span
        v-if="icon"
        :class="cx('flex size-9 shrink-0 items-center justify-center rounded-lg', iconWrap)"
      >
        <component :is="icon" :size="16" />
      </span>
    </div>
  </div>
</template>
